// Confirming a task delete. Deliberately SHORT, and deliberately not
// DeleteConfirmModal: that dialog makes you type the record's name because deleting a
// retainer or a job destroys billing history that cannot be reconstructed, and the
// friction is proportionate to the loss. A task is a single row with nothing beneath it
// — the thing being deleted is usually a line typed by mistake a minute ago — so the
// same guard would be ceremony, and ceremony asked for routinely stops being read.
//
// What it keeps from the shared dialog is the part that matters at any size: the task is
// NAMED at the top, so the confirmation cannot be given against the wrong row after a
// mis-click on the board behind it; the delete is red, so it does not look like the
// cancel beside it; and a refused delete leaves the dialog open with the error, since
// nothing was destroyed and it can simply be retried.
import { useState } from 'react';
import he from '../i18n/he';
import Modal from './Modal';
import Button from './Button';
import { ErrorText } from './Loader';

export default function TaskDeleteModal({ task, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const confirm = async () => {
    setBusy(true);
    setError(null);
    try {
      await onDeleted();
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <Modal title={he.tasks.deleteTitle} onClose={onClose}>
      <p>{he.tasks.deleteQuestion}</p>

      <div className="modal-subject">
        <strong>{task.title}</strong>
        {task.note && <div className="muted small-note">{task.note}</div>}
      </div>

      {task.list && <p className="delete-warning">{he.lists.deleteWithTask(task.list.total)}</p>}
      <p className="delete-warning">{he.common.deleteIrreversible}</p>

      <div className="actions">
        <Button
          onClick={confirm}
          disabled={busy}
          variant="danger"
        >
          {busy ? he.common.deleting : he.common.deletePermanently}
        </Button>
        <Button variant="subtle" onClick={onClose} disabled={busy}>{he.common.cancel}</Button>
      </div>

      {error && <ErrorText error={error} />}
    </Modal>
  );
}
